import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

//const baseUrl = config.baseUrl;
const baseUrl = "https://166.bodecom.com";

const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};
// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 50,
    fontFamily: "Helvetica",
  },
  content: {
    flexGrow: 1,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 10,
    marginTop: 10,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },

  textareaLabel: {
    fontSize: 10,
    lineHeight: 1.5,
    textAlign: "justify",
    marginBottom: 12,
    marginTop: 12,
    fontFamily: "Helvetica",
  },
  header: {
    marginBottom: 20,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  // Para la última celda de la fila quitamos el borde derecho
  lastCell: {
    borderRightWidth: 0,
  },
  banner: {
    width: "100%",
    height: 40,
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    marginTop: 10,
  },

  tableInfo: {
    fontSize: 10,
    fontFamily: "Helvetica",
    textAlign: "left",
  },
  tableTitle: {
    fontWeight: "bold",
  },
  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  codeText: {
    fontSize: 9,
    fontFamily: "Helvetica",
    textAlign: "center",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  text: {
    fontSize: 10,
    fontFamily: "Helvetica",
    textAlign: "left",
  },

  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#052956", // Color de fondo para el encabezado
    fontWeight: "bold",
    color: "#ffffff",
  },
  tableCol: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    padding: 5,
    textAlign: "center",
    borderLeftWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    fontSize: 10,
    padding: 5,
    fontFamily: "Helvetica",
  },

  tableCol30: {
    width: "30%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
    wordBreak: "break-word",
  },
  tableCol70: {
    width: "70%",
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
    wordBreak: "break-word",
  },
  tableCol25: {
    width: "25%",
    padding: 5,
    textAlign: "left",
    borderRightWidth: 1,
    borderRightColor: "#000",
    fontSize: 10,
  },

  tableCol100: {
    width: "100%",
    padding: 5,
    fontSize: 10,
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
  },

  signatureBlock: {
    marginTop: 20,
    marginBottom: 20,
    width: "100%",
  },
  signatureHeader: {
    fontSize: 10,
    fontWeight: "bold",
    marginBottom: 10,
    fontFamily: "Helvetica-Bold",
  },
  signatureContent: {
    marginLeft: 20,
    marginTop: 5,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    width: "60%",
    marginBottom: 5,
  },
  signatureLabel: {
    fontSize: 10,
    marginTop: 5,
    marginBottom: 5,
  },
  signatureText: {
    fontSize: 10,
    marginBottom: 3,
  },

  imageContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    marginVertical: 10,
  },
  image: {
    width: 150,
    height: 150,
    margin: 5,
  },
  boldText: {
    fontWeight: "bold",
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },

  signatureImage: {
    width: 200,
    height: 70,
  },
  // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 30,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Helvetica-Bold", // <-- Esta línea hace el texto en negrita
  },
});

const MyDocument = ({ formData }) => {
  if (!formData) return null;

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.content}>
          <View fixed>
            <View style={styles.headerTable} fixed>
              <View style={styles.logoColumn}>
                <Image style={styles.banner} src={"Banner_membrete.png"} />
              </View>

              <View style={styles.infoColumn}>
                <View style={styles.codeRow}>
                  <Text style={styles.codeText}>CÓDIGO: IR-F-113</Text>
                </View>
                <View style={styles.dateVersionRow}>
                  <View style={styles.dateCell}>
                    <Text style={[styles.text, { fontSize: 9 }]}>
                      FECHA: 2020-07-14
                    </Text>
                  </View>
                  <View style={styles.versionCell}>
                    <Text style={[styles.text, { fontSize: 9 }]}>
                      VERSIÓN: V-1
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>

          <Text style={styles.title}>
            ACTA DE VISITA PROYECTO PRODUCTIVO PAATI
          </Text>
          <Text style={styles.text}>Convenio y/o contrato No. de 202___</Text>

          <View style={styles.infoContainer} wrap={false}>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <View style={[styles.tableCol100, styles.lastCell]}>
                  <Text style={{ textAlign: "center" }}>
                    TEMÁTICAS DE LA VISITA
                  </Text>
                </View>
              </View>

              <View style={styles.tableRow}>
                <View style={styles.tableCol25}>
                  <Text style={styles.boldText}>Temática</Text>
                </View>
                <View style={styles.tableCol25}>
                  <Text style={styles.boldText}>Fortalecimiento</Text>
                </View>
                <View style={styles.tableCol25}>
                  <Text style={styles.boldText}>Capacitación</Text>
                </View>
                <View style={[styles.tableCol25, styles.lastCell]}>
                  <Text style={styles.boldText}>Factor</Text>
                </View>
              </View>
              {formData.lista_capacitaciones &&
              formData.lista_capacitaciones.length > 0 ? (
                formData.lista_capacitaciones.map((row, index) => (
                  <View style={styles.tableRow} key={index}>
                    <View style={styles.tableCol25}>
                      <Text style={styles.tableCell}>{row.tema || ""}</Text>
                    </View>
                    <View style={styles.tableCol25}>
                      <Text style={styles.tableCell}>{row.area || ""}</Text>
                    </View>
                    <View style={styles.tableCol25}>
                      <Text style={styles.tableCell}>{row.tematica || ""}</Text>
                    </View>
                    <View style={[styles.tableCol25, styles.lastCell]}>
                      <Text style={styles.tableCell}>{row.factor || ""}</Text>
                    </View>
                  </View>
                ))
              ) : (
                <View style={[styles.tableRow, styles.lastCell]}>
                  <Text style={styles.tableCell}></Text>
                </View>
              )}
            </View>
          </View>

          <View style={styles.infoContainer}>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <View style={[styles.tableCol100, styles.lastCell]}>
                  <Text style={{ textAlign: "center" }}>
                    INFORMACIÓN GENERAL
                  </Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>VISITA N°</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.numero_visita || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>FECHA VISITA</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.fecha_registro || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>GRUPO TERRITORIAL</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.grupoTerritorial || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>DEPARTAMENTO</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.departamento || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>MUNICIPIO</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.municipio || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>VEREDA / CORREGIMIENTO</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.vereda || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>CODIGO PRE PP</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.codigoPREPP || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>
                  NOMBRE DEL PROYECTO PRODUCTIVO
                </Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.nombreProyecto || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>QUIEN RECIBE LA VISITA</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.quienRecibeVisita || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>
                  NOMBRE COMPLETO DEL TITULAR DEL PROYECTO
                </Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.nombreParticipante || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>NÚMERO DE IDENTIFICACIÓN</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.numeroIdentificacion || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>CODIGO -SIRR</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.codigoSIRR || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>HORA INICIO</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.horaInicio || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>HORA FINALIZACIÓN</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.horaFin || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>
                  NUMERO DE PERSONAS QUE PARTICIPAN EN LA VISITA
                </Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.numeroPersonasParticipan || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>No. DE HOMBRES</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.numeroHombres || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>No. DE MUJERES</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.numeroMujeres || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>LATITUD</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.latuser || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>LONGITUD</Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.lnguser || ""}
                </Text>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>
                  LINEA PRODUCTIVA DEL PROYECTO
                </Text>
                <Text style={[styles.tableCol30, styles.lastCell]}>
                  {formData?.linea_productiva || ""}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.infoContainer} wrap={false}>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <View style={[styles.tableCol100, styles.lastCell]}>
                  <Text style={{ textAlign: "center" }}>
                    ASPECTOS METODOLÓGICOS{" "}
                  </Text>
                </View>
              </View>

              <View style={styles.tableRow}>
                <Text style={styles.tableCol70}>
                  MODALIDAD DE SESIÓN CAPACITACIÓN
                </Text>
                {formData?.modalidad_sesion_capacitacion === "Otro" ? (
                  <Text style={[styles.tableCol30, styles.lastCell]}>
                    {formData?.otra_modalidad_sesion_capacitacion || ""}
                  </Text>
                ) : (
                  <Text style={[styles.tableCol30, styles.lastCell]}>
                    {formData?.modalidad_sesion_capacitacion || ""}
                  </Text>
                )}
              </View>
            </View>
          </View>

          {/* Título de la descripción del proyecto */}
          <Text style={styles.title}>
            ACTIVIDADES DESARROLLADAS EN LA VISITA
          </Text>

          {/* Fila de la tabla para la descripción del proyecto */}
          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              {formData?.actividadesDesarrolladas || ""}
            </Text>
          </View>

          <View style={styles.infoContainer}>
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <View style={[styles.tableCol100, styles.lastCell]}>
                  <Text style={{ textAlign: "center" }}>
                    AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
                  </Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 1. Acompañamiento y
                  fortalecimiento técnico y financiero
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor1 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 2. Fortalecimiento organizativo y
                  asociativo
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor2 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de Actividades: Factor 3. Acompañamiento y
                  fortalecimiento a procesos de mercadeo y comercialización
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor3 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 4. Acompañamiento y gestión para
                  la articulación e incidencia territorial
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor4 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 5. Acompañamiento para la
                  Implementación de los enfoques diferenciales
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor5 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 6. Generación de condiciones para
                  el acceso a tierra:
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor6 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 7. Promoción de la articulación
                  interinstitucional para la seguridad humana en los
                  territorios:
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor7 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Avance de actividades Factor 8. Acompañamiento para la
                  implementación de los planes/programas de manejo ambiental
                  (PMA) y el fortalecimiento de relaciones sostenibles entre
                  seres humanos y otras formas de vida:
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.avanceFactor8 || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Próxima Sesión
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.proximaSesion || ""}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={styles.tableCol30} wrap>
                  Modalidad
                </Text>
                <Text style={[styles.tableCol70, styles.lastCell]} wrap>
                  {formData?.modalidad || ""}
                </Text>
              </View>
            </View>
          </View>

          <Text style={styles.title}>HALLAZGOS</Text>

          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              {formData?.hallazgos || ""}
            </Text>
          </View>

          <Text style={styles.title}>RECOMENDACIONES</Text>

          <View style={styles.infoContainer}>
            <Text style={styles.textareaLabel}>
              {formData?.recomendaciones || ""}
            </Text>
          </View>

          <Text style={styles.title}>ACUERDOS</Text>
          <View style={styles.table}>
            {/* Fila de cabecera */}
            <View style={[styles.tableRow, styles.tableHeader]}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>COMPROMISO</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>RESPONSABLE</Text>
              </View>
              <View style={[styles.tableCol, styles.lastCell]}>
                <Text style={styles.tableCell}>FECHA</Text>
              </View>
            </View>
            {/* Filas de datos */}
            {formData.acuerdos && formData.acuerdos.length > 0 ? (
              formData.acuerdos.map((row, index) => (
                <View style={styles.tableRow} key={index}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{row.compromiso || ""}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>
                      {row.responsable || ""}
                    </Text>
                  </View>
                  <View style={[styles.tableCol, styles.lastCell]}>
                    <Text style={styles.tableCell}>
                      {row.fechaLimite || ""}
                    </Text>
                  </View>
                </View>
              ))
            ) : (
              <View style={[styles.tableRow, styles.lastCell]}>
                <Text style={styles.tableCell}></Text>
              </View>
            )}
          </View>

          {/* Firma profesional tecnico */}
          <View style={styles.signatureBlock} wrap={false}>
            <Text style={styles.signatureHeader}>
              FIRMA PROFESIONAL ASISTENTE TÉCNICO
            </Text>
            <View style={styles.signatureContent}>
              {formData?.firmaProfesionalAsistenteTecnico &&
              formData?.firmaProfesionalAsistenteTecnico.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
                  src={`${
                    baseUrl + formData.firmaProfesionalAsistenteTecnico
                  }?t=${Date.now()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 0, // Sin borde
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 12 }}>
                    {" "}
                    {/* Tamaño más pequeño */}
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                NOMBRE: {formData?.nombreProfesionalAsistenteTecnico || ""}
              </Text>
              <Text style={styles.signatureText}>
                CC: {formData?.ccProfesionalAsistenteTecnico || ""}
              </Text>
              <Text style={styles.signatureText}>
                PROFESIÓN:{" "}
                {formData?.ProfesionProfesionalAsistenteTecnico || ""}
              </Text>
            </View>
          </View>

          {/* Firma profesional tecnico 2 */}
          <View style={styles.signatureBlock} wrap={false}>
            <Text style={styles.signatureHeader}>
              FIRMA PROFESIONAL ASISTENTE TÉCNICO 2
            </Text>
            <View style={styles.signatureContent}>
              {formData?.firmaProfesionalAsistenteTecnico_2 &&
              formData?.firmaProfesionalAsistenteTecnico_2.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
                  src={`${
                    baseUrl + formData.firmaProfesionalAsistenteTecnico_2
                  }?t=${Date.now()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 0, // Sin borde
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 12 }}>
                    {" "}
                    {/* Tamaño más pequeño */}
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                NOMBRE: {formData?.nombreProfesionalAsistenteTecnico_2 || ""}
              </Text>
              <Text style={styles.signatureText}>
                CC: {formData?.ccProfesionalAsistenteTecnico_2 || ""}
              </Text>
              <Text style={styles.signatureText}>
                PROFESIÓN:{" "}
                {formData?.ProfesionProfesionalAsistenteTecnico_2 || ""}
              </Text>
            </View>
          </View>

          {/* Firma del titular */}
          <View style={styles.signatureBlock} wrap={false}>
            <Text style={styles.signatureHeader}>
              FIRMA TITULAR O TERCERO AUTORIZADO
            </Text>
            <View style={styles.signatureContent}>
              {formData?.firmaTitular &&
              formData?.firmaTitular.trim() !== "" ? (
                <Image
                  style={styles.signatureImage}
                  src={`${baseUrl + formData.firmaTitular}?t=${Date.now()}`}
                />
              ) : (
                <View
                  style={[
                    styles.signatureImage,
                    {
                      justifyContent: "center",
                      alignItems: "center",
                      borderWidth: 0, // Sin borde
                    },
                  ]}
                >
                  <Text style={{ color: "#888", fontSize: 12 }}>
                    {" "}
                    {/* Tamaño más pequeño */}
                    Firma no disponible
                  </Text>
                </View>
              )}

              <View style={styles.signatureLine} />
              <Text style={styles.signatureText}>
                NOMBRE: {formData?.nombreTitular || ""}
              </Text>
              <Text style={styles.signatureText}>
                CC: {formData?.ccTitular || ""}
              </Text>
            </View>
          </View>

          <Text style={styles.title}>ANEXOS</Text>

          <View wrap={false}>
            <Text style={[styles.title, { textAlign: "left" }]}>
              FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO
            </Text>
            <View style={styles.imageContainer}>
              {formData.fotografia_usuario &&
              formData.fotografia_usuario.length > 0 ? (
                chunkArray(formData.fotografia_usuario, 3).map(
                  (chunk, rowIndex) => (
                    <View style={styles.imageRow} key={rowIndex}>
                      {chunk.map((foto, index) => (
                        <Image
                          key={index}
                          style={styles.image}
                          source={{
                            uri: `${baseUrl}${foto}?t=${new Date().getTime()}`,
                          }}
                        />
                      ))}
                    </View>
                  )
                )
              ) : (
                <Text style={[styles.title, { fontSize: 12 }]}>
                  No hay fotografías
                </Text>
              )}
            </View>
          </View>

          <View wrap={false}>
            <Text style={[styles.title, { textAlign: "left" }]}>
              FOTOGRAFÍA (BUENA DEFINICIÓN) EN EL LUGAR DONDE SE DESARROLLA EL
              PROYECTO PRODUCTIVO
            </Text>
            <View style={styles.imageContainer}>
              {formData.fotografias_lugar &&
              formData.fotografias_lugar.length > 0 ? (
                chunkArray(formData.fotografias_lugar, 3).map(
                  (chunk, rowIndex) => (
                    <View style={styles.imageRow} key={rowIndex}>
                      {chunk.map((foto, index) => (
                        <Image
                          key={index}
                          style={styles.image}
                          source={{
                            uri: `${baseUrl}${foto}?t=${new Date().getTime()}`,
                          }}
                        />
                      ))}
                    </View>
                  )
                )
              ) : (
                <Text style={[styles.title, { fontSize: 12 }]}>
                  No hay fotografías
                </Text>
              )}
            </View>
          </View>

          <View wrap={false}>
            <Text style={[styles.title, { textAlign: "left" }]}>
              FOTOGRAFÍA (BUENA DEFINICIÓN), QUE REPRESENTE LA FINALIDAD DEL
              PROYECTO PRODUCTIVO{" "}
            </Text>
            <View style={styles.imageContainer}>
              {formData.fotografia_finalidad &&
              formData.fotografia_finalidad.length > 0 ? (
                chunkArray(formData.fotografia_finalidad, 3).map(
                  (chunk, rowIndex) => (
                    <View style={styles.imageRow} key={rowIndex}>
                      {chunk.map((foto, index) => (
                        <Image
                          key={index}
                          style={styles.image}
                          source={{
                            uri: `${baseUrl}${foto}?t=${new Date().getTime()}`,
                          }}
                        />
                      ))}
                    </View>
                  )
                )
              ) : (
                <Text style={[styles.title, { fontSize: 12 }]}>
                  No hay fotografías
                </Text>
              )}
            </View>
          </View>

          <View wrap={false}>
            <Text style={[styles.title, { textAlign: "left" }]}>
              FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO DILIGENCIANDO EL ACTA
              DE LA VISITA
            </Text>
            <View style={styles.imageContainer}>
              {formData.fotografia_acta &&
              formData.fotografia_acta.length > 0 ? (
                chunkArray(formData.fotografia_acta, 3).map(
                  (chunk, rowIndex) => (
                    <View style={styles.imageRow} key={rowIndex}>
                      {chunk.map((foto, index) => (
                        <Image
                          key={index}
                          style={styles.image}
                          source={{
                            uri: `${baseUrl}${foto}?t=${new Date().getTime()}`,
                          }}
                        />
                      ))}
                    </View>
                  )
                )
              ) : (
                <Text style={[styles.title, { fontSize: 12 }]}>
                  No hay fotografías
                </Text>
              )}
            </View>
          </View>

          <View wrap={false}>
            <Text style={[styles.title, { textAlign: "left" }]}>
              FOTOGRAFÍA (BUENA DEFINICIÓN) DONDE SE EVIDENCIE UNA ACTIVIDAD
              PROPIA DEL PROYECTO PRODUCTIVO
            </Text>
            <View style={styles.imageContainer}>
              {formData.fotografia_actividad &&
              formData.fotografia_actividad.length > 0 ? (
                chunkArray(formData.fotografia_actividad, 3).map(
                  (chunk, rowIndex) => (
                    <View style={styles.imageRow} key={rowIndex}>
                      {chunk.map((foto, index) => (
                        <Image
                          key={index}
                          style={styles.image}
                          source={{
                            uri: `${baseUrl}${foto}?t=${new Date().getTime()}`,
                          }}
                        />
                      ))}
                    </View>
                  )
                )
              ) : (
                <Text style={[styles.title, { fontSize: 12 }]}>
                  No hay fotografías
                </Text>
              )}
            </View>
          </View>
        </View>

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const PdfAlmacenarVisitaTecnica = ({ formData }) => {
  return <MyDocument formData={formData} />;
};

export default PdfAlmacenarVisitaTecnica;
